import React from 'react';
import { SiGithub, SiLinkedin, SiGooglescholar, SiMaildotru } from 'react-icons/si';
import { IoEarth } from 'react-icons/io5';

import './index.css';

const Component = (props) => {
    const { github, linkedIn, googleScholar, mail, website } = props;
    return (
        <div>
            <p className="social-icons">
                <a target="blank" href={github}>
                    <SiGithub />
                </a>
                <a target="blank" href={linkedIn}>
                    <SiLinkedin />
                </a>
                <a target="blank" href={googleScholar}>
                    <SiGooglescholar />
                </a>
                <a target="blank" href={`mailto:${mail}`}>
                    <SiMaildotru />
                </a>
                <a target="blank" href={website}>
                    <IoEarth />
                </a>
            </p>
        </div>
    );
};

export default Component;
